module.exports = __webpack_public_path__ + "static/shoe-layers-4-b0b2aca487406f266f182fa2b8d71822.png";